import { IEpisode } from '@redmedical/datamodels/shared-datamodels';
import { EpisodeGesetzlichScheinart } from '@redngapps/shared/types';

const scheinarten = new Map<string, string>([
  [EpisodeGesetzlichScheinart.AMBULANT, 'Ambulante Behandlung'],
  [EpisodeGesetzlichScheinart.UEBERWEISUNG, 'Überweisung'],
  [EpisodeGesetzlichScheinart.BELEGAERZTLICH, 'Belegärztliche Behandlung'],
  [EpisodeGesetzlichScheinart.NOTFALL, 'Notfall/Vertretung'],
]);

export function getEpisodeScheinartDisplayName(episode: Pick<IEpisode, 'GesetzlicheEpisode'>): string | undefined {
  const scheinart = episode.GesetzlicheEpisode.scheinart;
  return scheinarten.get(typeof scheinart === 'string' ? scheinart : scheinart.V);
}
